export var cancelRequestPlugin = function (eventNameToCancelRequests) { return function () { return ({
    onTransitionStart: function (_, fromState) {
        if (Boolean(fromState)) {
            var event_1 = new CustomEvent(eventNameToCancelRequests, {
                detail: { id: fromState.name },
            });
            document.dispatchEvent(event_1);
        }
    },
}); }; };
